/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Page_TitleInputs */

const vi_warehouse_defects_page_title = /** @type {(inputs: Warehouse_Defects_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo cáo sản phẩm đóng lỗi`)
};

/**

* @param {Warehouse_Defects_Page_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_page_title = /** @type {((inputs?: Warehouse_Defects_Page_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Page_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_page_title(inputs)
});